const slickSliderHelper = require('./components/slickSlider/slickSliderHelper.js');

// Event Handlers
// new component architecture
function _registerEventHandlers() {

    $(document).ready(function () {
        setupAlerts();

        setupSliderSections();
        setupYoutubeIframeVideos();
        setupVacationTiles();
    });

    function setupYoutubeIframeVideos() {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // called by youtube iframe_api when video is ready
    window.onYouTubeIframeAPIReady = function () {
        setupVideos();
    }

    function setupVideos() {
        var $videos = $('.video-item:not(.active)');

        var players = [];
        $.each($videos, function (idx) {
            var $video = $(this);
            var $videoContainer = $video.find('iframe');
            players[idx] = new YT.Player($videoContainer[0].id, {
                events: {
                    onReady: function (e) {
                        $video.on('click', function () {
                            var $this = $(this);
                            $this.addClass('active');
                            e.target.mute();
                            e.target.playVideo();
                        });
                    }
                }
            });
        });
    }

    function setupSliderSections() {
        $.when(setupLocationsVisited()).done(function () {
            setupVacationSliders();

            initLeftGlideArrow();
        });
    }

    function setupLocationsVisited() {
        var dfdArr = [];
        var vacationSliders = document.querySelectorAll('.vacation-slider.glide');
        vacationSliders.forEach(function (vacationSlider) {
            var dfd = $.Deferred();
            new Vue({
                el: '#' + vacationSlider.id,
                mounted: function () {
                    dfd.resolve();
                }
            });
            dfdArr.push(dfd);
        });

        return $.when.apply(null, dfdArr);
    }

    function setupVacationSliders() {
        slickSliderHelper.initialize('.four-col-slider', {
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3.1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2.1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    /*
     *  Left glide arrow could be intentionally hidden on load.
     *  If so, it should always be shown after a user starts
     *  paging around the slider
     */
    function initLeftGlideArrow() {
        var $glideNavWrappers = $('.glide__arrows');
        $glideNavWrappers.each(function () {
            var $this = $(this);
            var $glideRight = $this.find('.glide__arrow--right');
            if ($glideRight && $glideRight.length > 0) {
                $glideRight.one('click', function () {
                    $this.removeClass('glide__control--hideleft');
                });
            }
        });

        var $glideRoots = $('.glide');
        $glideRoots.each(function () {
            var $this = $(this);
            var $glideNavWrapper = $this.find('.glide__arrows');
            if ($glideNavWrapper && $glideNavWrapper.length > 0) {
                $this.one('glide-swipe', function () {
                    $glideNavWrapper.removeClass('glide__control--hideleft');
                });
            }
        });
    }

    function setupAlerts() {
        var $alertCta = $('.get-alert .popup-button');
        if ($alertCta.length > 0) {
            $alertCta.fancybox({
                padding: [0],
                fitToView: true,
                scrolling: 'no',
                maxWidth: '923',
                wrapCSS: 'home-alert-popup-wrap',
                autoSize: true,
                autoResize: true,
                tpl: {
                    closeBtn: '<a title="close" class="dialog-close" href="javascript:;"></a>'
                },
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none'
            });
        }
    }

    function setupVacationTiles() {
        var dfdArr = [];
        var vactionTileRows = document.querySelectorAll('.home-vacation-tiles-row');
        vactionTileRows.forEach(function (row) {
            var dfd = $.Deferred();
            new Vue({
                el: '#' + row.id,
                mounted: function () {
                    dfd.resolve();
                }
            });
            dfdArr.push(dfd);
        });

        return $.when.apply(null, dfdArr);
    }
}
_registerEventHandlers();